module.exports = __webpack_public_path__ + "img/Group 638.4c3457e4.png";